import { CustomsDocsApi } from "@/Apis/CustomsDocsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useCustomsDocsApi(): CustomsDocsApi {
  const { accessToken } = useAuthentication();

  return new CustomsDocsApi(getConfig().basePath, accessToken);
}
